import { Logger, toResponseError, type TaskData, type TaskUpdateInput, type TaskUpdateSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTaskCache } from './cache'

const logger = new Logger('useUpdateTask')

export function useUpdateTask(): UpdateHookResponse<TaskUpdateInput['task'], TaskData> {
  logger.verbose('calling useUpdateTask')
  const cache = useTaskCache()

  const mutation = useTantalimMutation<TaskUpdateInput, TaskUpdateSuccess>({
    url: '/task/update',
  })

  async function update(task: TaskUpdateInput['task']): Promise<TaskData> {
    try {
      logger.verbose('starting update')
      const response = await mutation.mutateAsync({ task })
      if (response.task) {
        cache.clearList()
        cache.clearManagementList()
      }
      logger.verbose('done with update')
      return response.task
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
